module.exports = __webpack_public_path__ + "static/media/news.75065f0a.wav";